// extracted by mini-css-extract-plugin
export default {"noticeContainer":"_5oWdH","newNotice":"jwYEa","noticeBody":"N598S","infoGroup":"YPX1R","userNickname":"OYDjF","commentDate":"xNkjL","tooltip":"I5vVo"};